module.exports = __webpack_public_path__ + "static/media/blank_profile.df68fb6f.svg";